import dayjs from 'dayjs'

function formatTime (datetime) {
  if (!datetime) {
    return ''
  }

  let now = new Date()
  let target = new Date(datetime)
  let diff = now - target
  if ( diff > 6 * 60 * 60 * 1000) {
    return dayjs(datetime).format('YYYY年MM月DD日 HH:mm')  // 2017年8月30日 17:45
  }

  if (diff > 1 * 60 * 60 * 1000) {
    let sign = diff / (60 * 60 * 1000)
    sign = Math.round(sign)
    return String(sign) + '小时前' 
  } else if (diff > 60 * 1000) {
    let sign = diff / (60 * 1000)
    sign = Math.round(sign)
    return String(sign) + '分钟前'
  } else {
    return '几秒前'
  }

}

function standardTime (datetime) {
  return dayjs(datetime).format('YYYY年MM月DD日 HH:mm')
}

export {
  formatTime,
  standardTime
}
